import { jsx } from "react/jsx-runtime";
import { useRef } from "react";
import { c as clsx } from "../../../../chunks/clsx-DF9QTL9H.js";
import { useFocusManagement } from "./hooks/useFocusManagement.js";
import { useModalContext } from "./hooks/useModalContext.js";
import { $ as $a11501f3d1d39e6c$export$ea8f71083e90600f, a as $9bf71ea28793e738$export$20e40289641fbbb6 } from "../../../../chunks/import-D56pdwQG.js";
const ModalContainer = ({
  className,
  children,
  component,
  transitionStyles = {},
  ...props
}) => {
  const {
    animationTimeout,
    isDismissable,
    isKeyboardDismissDisabled,
    isOpen,
    onClose,
    restoreFocus,
    shouldMount,
    state
  } = useModalContext();
  const overlayRef = useRef(null);
  const { overlayProps } = $a11501f3d1d39e6c$export$ea8f71083e90600f(
    {
      isDismissable,
      isKeyboardDismissDisabled,
      isOpen,
      onClose
    },
    overlayRef
  );
  useFocusManagement({
    isOpen,
    overlayRef,
    restoreFocusDelay: animationTimeout,
    shouldMount,
    shouldRestoreFocus: restoreFocus
  });
  const Component = component || "div";
  return /* @__PURE__ */ jsx(
    $9bf71ea28793e738$export$20e40289641fbbb6,
    {
      restoreFocus: restoreFocus && !shouldMount,
      contain: true,
      autoFocus: !shouldMount,
      children: /* @__PURE__ */ jsx(
        Component,
        {
          className: clsx(className, state ? transitionStyles[state] : ""),
          ref: overlayRef,
          ...overlayProps,
          ...props,
          children
        }
      )
    }
  );
};
export {
  ModalContainer
};
